import React from "react"
import PropTypes from "prop-types"


class MenuItem extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return(
      <div
        className="menuItem"
        onClick={() => this.props.onClick()}>
        <div className={this.props.iconName}></div>
        <h5>{this.props.title}</h5>
      </div>
    )
  }

}

export default MenuItem;
